import './App.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from './views/Home';
import Map from './views/Map';
import Stats from './views/Stats';
import Leaderboard from './views/Leaderboard';
import Tools from './views/Tools';
import Play from './views/Play';
import NotFound from './views/NotFound';
import LogOut from './views/LogOut';

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/map" element={<Map />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/play" element={<Play />} />
          <Route path="/logout" element={<LogOut />} />

          <Route path="/:landingKey" element={<Home />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
    </Router>
  );
}

export default App;
